
seedWebApp.controller('ShowImageCtrl', ['$scope', '$uibModalInstance', '$window', 'StoreService', 'product', 'contactID', '$timeout',
    function ShowImageCtrl($scope, $uibModalInstance, $window, StoreService, product, contactID, $timeout) {

        console.log('showImageCtrl');
        console.log(product);

        $scope.product = product;
        $scope.contactID = contactID;
        //$scope.getPartTranslation = StoreUtils.getPartTranslation;

        $scope.ok = function () {
            $uibModalInstance.close();
        };

        $scope.openNewTab = function (version) {
            var newUrl = version.Image;
            $window.open(newUrl, '_blank');
            $scope.cancel();
        };

        $scope.doPrint = function () {
            $window.print();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        //$scope.imageLoading = true;
        //StoreService.getSpecImage($scope.version.SpecID, $scope.contactID).then(function (response) {
        //    $scope.version.SpecImageUrl = response.data;
        //});

}]);